// extracted by mini-css-extract-plugin
module.exports = {"actionsContainer":"style_actionsContainer__HX24c","alignRightContainer":"style_alignRightContainer__3vr99","spacer":"style_spacer__3ABob"};